module.exports = __webpack_public_path__ + "static/media/notice.2b8e167a.png";